const MAX_VISIBLE_BANNERS = 4;

function pickRandomBannerIndices(bannerCount) {
  const indices = new Set();

  while (indices.size < MAX_VISIBLE_BANNERS) {
    indices.add(Math.floor(Math.random() * bannerCount) + 1);
  }

  return [...indices];
}

function showBannerByIndex(index) {
  const banner = document.querySelector(`.sponsored-banner-${index}`);
  if (banner) {
    banner.style.display = 'flex';
  }
}

export function revealSponsoredBanners() {
  const banners = document.querySelectorAll('.sponsored-banners');
  const bannerCount = banners.length;

  if (bannerCount === 0) {
    return;
  }

  if (bannerCount <= MAX_VISIBLE_BANNERS) {
    banners.forEach((banner) => {
      banner.style.display = 'flex';
    });
    return;
  }

  pickRandomBannerIndices(bannerCount).forEach(showBannerByIndex);
}
